const layoutConfig = {
  name: 'isAbsoluteLayout',
  text: '布局',
  type: 'radioGroup',
  defaultValue: true,
  options: [
    { value: true, text: '固定位置' },
    { value: false, text: '顺序排布' },
  ],
};

export { layoutConfig };

export default [{
  type: 'tab',
  active: '0',
  items: [{
    title: '属性',
    labelWidth: '100px',
    items: [layoutConfig, {
      text: '组件名称',
      name: 'name',
      onChange(vm, v, { model }) {
        // eslint-disable-next-line no-param-reassign,no-underscore-dangle
        model.report._module = v;
      },
    }, {
      text: 'type',
      name: 'type',
      type: 'hidden',
    }, {
      type: 'component',
      id: 'background',
    }, {
      type: 'component',
      id: 'rect',
    }],
  },
  {
    title: '高级',
    items: [{
      type: 'tab',
      active: '0',
      lazy: true,
      items: [{
        title: '属性',
        labelWidth: '100px',
        items: [{
          name: 'id',
          text: 'ID',
          type: 'display',
        }, {
          text: 'className',
          name: 'className',
        }, {
          type: 'fieldset',
          text: '上报',
          labelWidth: '100px',
          name: 'report',
          extensible: true,
          items: [{
            type: 'row',
            items: [{
              type: 'switch',
              name: 'custom',
              defaultValue: false,
              text: '自定义',
              tip: '选择自定义后可以手动修改上报内容，关闭后会自动生成上报内容',
            }],
          }, {
            name: 'module',
            items: [{
              text: '_module',
              disabled: (vm, { values }) => !values?.report?.custom,
              name: '_module',
            }],
          }],
        }],
      }, {
        type: 'component',
        id: 'script',
      }],
    }],
  },
  ],
}];
